import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import EntityAvailabilityConfig from "./Sections/EntityAvailabilityConfig";
import EntitySchedulingConfig from "./Sections/EntitySchedulingConfig";
import EntityRestrictionConfig from "./Sections/EntityRestrictionConfig";
import EntityTimeslotConfig from "./Sections/EntityTimeslotConfig";
import EntityAdditionalConfig from "./Sections/EntityAdditionalConfig";
import StackedFormRow from "../../../Components/StackedForm/StackedFormRow";
import { Collapse } from "@mui/material";
import EntityConfigSection from "../Components/EntityConfigSection";
import EntityPaymentConfig from "./Sections/EntityPaymentConfig";

export const defaultConfig = {
    isExpanded: true,

    id: 0,
    name: '',

    order: 0,

    restrictions: {
        blocks: [],
        units: [],
        groups: []
    },

    is_variable: 0,
    duration: null,
    max_simultaneous: 1,
    max_active_bookings: 0,
    max_per_day: 0,
    max_per_week: 0,
    max_per_month: 0,


    buffer_check: false,
    buffer: null,

    availability: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
    },

    min_advance_period: 0,
    min_advance_units: 'days',
    max_advance_period: 12,
    max_advance_units: 'months',

    recurring_bookings: false,

    override_calendar: false,
    overrides: {},

    visitors_enabled: false,
    visitors_type: '',
    visitors_entrance: '',
    sign_in_enabled: false,
    custom_form_enabled: false,
    custom_form: '',
    searched_at_sign_in_enabled: false,

    payment_enabled: false,
    payment_amount: 0,
    cancellation_window: false,
    payment_receipt_sent_to_email: false,
};


const EntityConfig = (props) => {
    const limitedConfigs = useSelector(
        state => state.admin.module.BOOKINGS.amenityForm.amenity.limited_configs
    );

    const errors = props.errors;

    const handleChange = (field, value) => {
        const updatedConfig = {
            ...props.config,
            [field]: value
        }
        props.onChange(updatedConfig)
    }

    const handleChanges = (changedData) => {
        const updatedConfig = {
            ...props.config,
            ...changedData
        };

        props.onChange(updatedConfig);
    }

    return (<>
        <div className="cell small-12">
            <div className="entity-config-header">
                <div className="entity-config-name">
                    {(props.config.name || <i>New Config</i>)}
                </div>
                <div className="entity-config-header-actions">
                    { Object.keys(errors).length > 0 &&
                        <span className="error-count">
                            {Object.keys(errors).length} error(s)
                        </span>
                    }

                    <a className="button primary"
                       onClick={e => props.onToggle()}
                    >
                        { props.isExpanded === false
                            ? <i className="fa fa-pencil"></i>
                            : <i className="fa fa-chevron-up"></i>
                        }
                    </a>

                    <a className="button primary"
                       onClick={e => props.onDelete(props.index)}
                    >
                        <i className="fa fa-trash-o"></i>
                    </a>
                </div>
            </div>
        </div>

        <Collapse in={props.isExpanded} unmountOnExit>
            <div className="cell small-12">
                <div className="grid-x margin-top-1 entity-config-body">
                    <div className="cell small-12">

                        <StackedFormRow
                            label="Config Name"
                            errorMessage={errors.name}
                            className="margin-bottom-0"
                            labelClassName="margin-bottom-0"
                            required
                        >
                            <input
                                type="text"
                                name="name"
                                value={props.config.name}
                                onChange={e => handleChange(e.target.name, e.target.value)}
                            />
                        </StackedFormRow>

                        <EntityRestrictionConfig
                            restrictions={props.config.restrictions}
                            errors={errors}
                            isExpanded
                            onChange={handleChange}
                        />

                        { !limitedConfigs && (
                            <>
                                <EntityTimeslotConfig
                                    config={props.config}
                                    errors={errors}
                                    isExpanded
                                    onChange={handleChange}
                                />

                                <EntityAvailabilityConfig
                                    config={props.config}
                                    errors={errors}
                                    isExpanded
                                    onChange={handleChange}
                                    onChanges={handleChanges}
                                />

                                <EntitySchedulingConfig
                                    config={props.config}
                                    errors={errors}
                                    isExpanded
                                    onChange={handleChange}
                                />

                                <EntityPaymentConfig
                                    config={props.config}
                                    errors={errors}
                                    isExpanded
                                    onChange={handleChange}
                                    onChanges={handleChanges}
                                />

                                <EntityConfigSection
                                    title="Category Overrides"
                                    isExpanded={true}
                                >
                                    <EntityAdditionalConfig
                                        config={props.config}
                                        parentConfig={props.parentConfig}
                                        errors={errors}
                                        onChange={handleChange}
                                    />
                                </EntityConfigSection>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </Collapse>
    </>)
}

EntityConfig.defaultProps = {
    config: null,
    isExpanded: false,
}

export default EntityConfig;
